'use strict';

var $ = require('jquery');
var enrolmentCtaButtonTemplate = require('../../../main/jade/templates/enrolment/enrolmentCtaButton.jade');
var disablingLayer = require('vhi-ui-framework/src/main/js/panels/disablingLayer');
var DOMPurify = require('dompurify');

function getConfig(uncheckedSource, uncheckedTarget, groupSchemeToken) {
    var MYVHI_SOURCE = /^myvhi$/i;
    var GROUPS_SOURCE = /^groups$/i;
    var INTL_GROUPS_SOURCE = /^intgroups$/i;

    var JOIN_TARGET = /^join-details-start$/i;
    var ADD_DEPENDANT_TARGET = /^add-dependant$/i;
    var INTL_JOIN_TARGET = /^join-details-start$/i;

    if (MYVHI_SOURCE.test(uncheckedSource)) {
        return {
            targetUrl: "/myvhi",
            ctaLabel: "Close",
            errorUrl: "/myvhi/error",
            groupSchemeToken: groupSchemeToken
        };
    }

    if (INTL_GROUPS_SOURCE.test(uncheckedSource)) {
        var resolvedIntlTarget = getIntlGroupsNavigationTarget(uncheckedTarget);
        return {
            targetUrl: resolvedIntlTarget,
            ctaLabel: "Continue",
            errorUrl: resolvedIntlTarget,
        };
    }
    else if (GROUPS_SOURCE.test(uncheckedSource)) {
        var resolvedTarget = getGroupsNavigationTarget(uncheckedTarget);
        return {
            targetUrl: resolvedTarget,
            ctaLabel: "Continue",
            errorUrl: resolvedTarget,
        };
    }

    redirectToGenericErrorPage('source');

    function getGroupsNavigationTarget(uncheckedTarget){
        if (JOIN_TARGET.test(uncheckedTarget)) {
            return "/groups/join-details-start";
        }

        if(ADD_DEPENDANT_TARGET.test(uncheckedTarget)) {
            return "/groups/add-dependant";
        }
        redirectToGenericErrorPage("source");
    }

    function getIntlGroupsNavigationTarget(uncheckedTarget){
        if (INTL_JOIN_TARGET.test(uncheckedTarget)) {
            return "/intgroups/join-details-start";
        }

        redirectToGenericErrorPage("source");
    }

    function redirectToGenericErrorPage(source) {
        console.error('Invalid ' + source + ' system. No configuration exists');
        window.location.replace('/groups/error');
    }
}

/**
 * @param schemeNo
 * @param config
 * @returns
 */
function updateEnrolmentContent(schemeNo, config) {

    var customEnrolmentContentUrl = '/online-services/enrolment-content/' + schemeNo + '/groups';

    $.ajax({
        type: 'GET',
        url: customEnrolmentContentUrl,
        dataType: 'json'
    }).done(function(data) {
        try {
            // Inject html into content area
            processCustomContent(data);
            disablingLayer.hideDisablingLayer();
        }
        catch(error) {
            handleException(config.errorUrl, error, schemeNo);
        }
    }).fail(function(jqXHR, textStatus, error) {
        // hide custom content region
        console.log( "error: status = %s", jqXHR.status);
        console.log( "error: responseText = %s", jqXHR.responseText);
        console.log( "error: textStatus = %s", textStatus);
        console.log( "error: error = %s", error);
        // bypass custom content and continue on journey.
        handleException(config.errorUrl, error, schemeNo);
    });

    updateCtaButton();

    /**
     * Process the custom content JSON object.
     */
    function processCustomContent(data) {
        var $enrolmentModal = $('#enrolment-modal');
        var html = DOMPurify.sanitize(data.enrolmentContent, { ADD_ATTR: ['target']});

        document.getElementById('custom-content').innerHTML = html;
        $enrolmentModal.modal('show');
        $enrolmentModal.on("hidden.bs.modal", function(){
            $('#custom-content').empty();
            $('#cta-button').empty();
        });
    }


    function updateCtaButton() {

        var dataObj = {
            ctaUrl: config.targetUrl,
            ctaTarget: "_self",
            ctaLabel: config.ctaLabel
        };

        var html = enrolmentCtaButtonTemplate(dataObj);
        var $placeHolder = $('#cta-button');
        $placeHolder.html(html);
    }

    /**
     * Logs the exception to the server and redirects to the desired URL.
     * @param targetUrl
     * @param error
     * @param schemeNo
     */
    function handleException(targetUrl, error, schemeNo){

        console.log( "Failed to display custom enrolment content" + error.message);

        try {
            var logEntry = "Failed to display custom enrolment content";
            logErrorToTheCustomEnrolmentContentService(logEntry, schemeNo);
        }
        catch(e) {
            console.log( "error: error = %s", "Failed to log error to server");
        }

        window.location.replace(targetUrl);
    }


    /**
     * Logs the <code>LogEntry</code> to the CustomEnrolmentContentService.
     *
     * @param logEntry
     * @param schemeNo
     */
    function logErrorToTheCustomEnrolmentContentService(logEntry, schemeNo){

        var logEntryConcat = "Failed to display cutom enrolment content. Error message: " + logEntry;
        var customEnrolmentContentLogUrl = '/online-services/enrolment-content/logs/' + schemeNo + '/groups/' + logEntryConcat;
        $.ajax({
            url : customEnrolmentContentLogUrl,
            dataType : 'json',
            contentType : 'application/json; charset=utf-8',
            data : null,
            async : true,
            type : 'POST'
        });
    }

}

module.exports = {
    getConfig: getConfig,
    updateEnrolmentContent: updateEnrolmentContent
};




//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/pages/enrolment-commons.js
// module id = dpXw
// module chunks = 14